import type { SquaresCompetitionProps, SquaresPayoutProps, SquaresTypeProps } from "../../types"
import { view_styles } from "../../constants/styles"
import { Icons } from "../../Components"
import React, { useState } from "react"
import { Button, Text, View } from "../../Components/Themed"
import { useColors } from "../../constants/useColors"

type SquaresDetailsProps = {
    squares_competition:SquaresCompetitionProps,
    squares_type?:SquaresTypeProps,
    hidden?:boolean,
    disable_collapse?:boolean,
    squares_payout_type?:SquaresPayoutProps
}

const SquaresDetails = ({ hidden, disable_collapse, squares_competition, squares_type, squares_payout_type }:SquaresDetailsProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);
    if(hidden){ return <></> }
    return (
        <View float nativeID="competition_details" style={{ minWidth:350, borderRadius:0 }}>
            <Button disabled={disable_collapse} transparent style={{ flexDirection:'row', alignItems:'center', backgroundColor:C.views.header, borderRadius:0 }} onPress={() => setExpanded(!expanded)}>
                <Icons.SettingsIcon size={18} color={C.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme="h1">COMPETITION DETAILS</Text>
                    <Text style={{ marginTop: 4 }} theme="description">Detailed Information on this competition</Text>
                </View>
                {!disable_collapse ?
                <Icons.ChevronIcon direction={expanded?'up':'down'} color={C.text.h1} size={8} />
                :<></>}
            </Button>
            {expanded ?
            <View transparent style={{ padding:20 }}>
                {squares_type ?
                <View transparent style={view_styles.body_row}>
                    <Text style={{flex:1}} theme="description">Type</Text>
                    <Text theme="h2">{squares_type.sq_type_name}</Text>
                </View>
                :<></>}
                <View transparent style={view_styles.body_row}>
                    <Text style={{flex:1}} theme="description">Initial Square Price</Text>
                    <Text theme="h2">${squares_competition.minimum_square_price.toFixed(2)}</Text>
                </View>
                {squares_payout_type ?
                <View transparent style={view_styles.body_row}>
                    <Text style={{flex:1}} theme="description">Payout</Text>
                    <Text theme="h2">{squares_payout_type.sq_payout_name.toUpperCase()}</Text>
                </View>
                :<></>}
                <View transparent style={view_styles.body_row}>
                    <Text style={{flex:1}} theme="description">Payout Frequency</Text>
                    <Text theme="h2">{squares_competition.payout_frequency} Quarters</Text>
                </View>
            </View>
            :<></>}
        </View>
    )
}

export default SquaresDetails